var _path, _polygon, _path2, _path3, _path4, _rect, _rect2, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandSanitizer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.2,16.6h-3.5v-1.5c0-0.3-0.2-0.5-0.5-0.5h-1v-2h1c0.3,0,0.5-0.2,0.5-0.5v-4c0-0.3-0.2-0.5-0.5-0.5h-4.9 c-0.3,0-0.5,0.2-0.5,0.5v0.5h-4.5c-1.6-0.1-2.9,1.2-3,2.8c0,0.1,0,0.1,0,0.2v1.5c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5 v-1.5h4.5v0.5c0,0.3,0.2,0.5,0.5,0.5h1v2h-1c-0.3,0-0.5,0.2-0.5,0.5v1.5h-3.5c-0.8,0-1.4,0.6-1.5,1.4v18c0.1,0.8,0.7,1.4,1.5,1.4 h12.9c0.8,0,1.4-0.6,1.5-1.4V18C31.6,17.2,31,16.6,30.2,16.6z M30.7,18v3.5h-6.5v-2h0.5c0.3,0,0.5-0.2,0.5-0.5v-1.5h5 C30.5,17.5,30.7,17.7,30.7,18z M16.8,33.5h13.9V36c0,0.3-0.2,0.5-0.5,0.5H17.3c-0.3,0-0.5-0.2-0.5-0.5V33.5z M30.7,32.5H16.8v-10 h13.9V32.5z M17.3,17.5h5V19c0,0.3,0.2,0.5,0.5,0.5h0.4v2h-6.4V18C16.8,17.7,17,17.5,17.3,17.5z M24.2,18.5h-1v-1h1V18.5z  M14.3,12.6v-1c0-1.1,0.9-2,2-2h4.5v1h-4.5c-0.5-0.1-0.9,0.3-1,0.8c0,0.1,0,0.1,0,0.2v1H14.3z M23.2,12.6h1v2h-1V12.6z M21.8,15.6 h3.9v1h-3.9V15.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A1A1A1",
    points: "24.7,16.6 25.7,16.6 25.7,15.6 24.7,15.6 22.8,15.6 21.8,15.6 21.8,16.6 22.8,16.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M30.2,17.5h-5V19c0,0.3-0.2,0.5-0.5,0.5h-0.5v2h6.5V18C30.7,17.7,30.5,17.5,30.2,17.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M16.8,21.5h6.4v-2h-0.4c-0.3,0-0.5-0.2-0.5-0.5v-1.5h-5c-0.3,0-0.5,0.2-0.5,0.5V21.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M17.3,36.5h12.9c0.3,0,0.5-0.2,0.5-0.5v-2.5H16.8V36C16.8,36.3,17,36.5,17.3,36.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 17.5,
    fill: "#A1A1A1",
    width: 1,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 12.6,
    fill: "#A1A1A1",
    width: 1,
    height: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M15.3,11.6c-0.1-0.5,0.3-0.9,0.8-1c0.1,0,0.1,0,0.2,0h4.5v-1h-4.5c-1.1,0-2,0.9-2,2v1h1V11.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M16.8,22.5v10h13.9v-10H16.8z M23.7,31.5c-2.2,0-4-1.8-4-4s1.8-4,4-4c2.2,0,4,1.8,4,4S25.9,31.5,23.7,31.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M26.7,27.5c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3s1.3,3,3,3C25.4,30.5,26.7,29.2,26.7,27.5z M25.2,28h-1v1 c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1h-0.9c-0.3,0-0.5-0.2-0.5-0.5S22,27,22.3,27h0.9v-1c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v1h1c0.3,0,0.5,0.2,0.5,0.5S25.5,28,25.2,28z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.7,27.5c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4s1.8,4,4,4C25.9,31.5,27.7,29.7,27.7,27.5z M23.7,30.5 c-1.7,0-3-1.3-3-3s1.3-3,3-3c1.7,0,3,1.3,3,3S25.4,30.5,23.7,30.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M25.7,27.5c0-0.3-0.2-0.5-0.5-0.5h-1v-1c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v1h-0.9 c-0.3,0-0.5,0.2-0.5,0.5S22,28,22.3,28h0.9v1c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1h1C25.5,28,25.7,27.8,25.7,27.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSanitizer);
export default __webpack_public_path__ + "static/media/hand_sanitizer.37ca3235b575082a40d76398d225f5cc.svg";
export { ForwardRef as ReactComponent };